<script setup>
import {useUsersStore} from "@/stores"

const usersStore = useUsersStore()
let myUser = null;
({myUser} = storeToRefs(usersStore))

const platinumApprovalInfo = ref({
  whyInterested: '',
  friendsOrFamilyMembers: '',
  membershipType: '',
  otherServices: '',
  reviewUnderstanding: '',
  seekingVerifiedProfile: '',
})

const submitForm = async () => {
  await usersStore.showLoadingOverlay()
  try {
    platinumApprovalInfo.value.submittedAt = new Date()
    myUser.value.platinumApprovalInfo = platinumApprovalInfo.value
    myUser.value.pendingPlatinumApproval = true

    await usersStore.updateMyUser()
    await usersStore.hideLoadingOverlay()
  } catch (e) {
    await usersStore.hideLoadingOverlay()
    console.log(e)
  }
}
</script>

<template>
  <div class="content-wrapper pa-4 pl-4 pr-4">
    <template v-if="myUser && myUser.isPlatinum">
      <div>
        <h3>You are already Platinum</h3>
        No need to apply, you already have all the benefits of Platinum<br>
        <VBtn
          width="fit-content"
          class="profile-header-edit-button mt-4 pl-1 pr-1"
          :to="{path:'/membership'}"
        >
          Membership Page
        </VBtn>
      </div>
    </template>
    <template v-else-if="myUser && myUser.platinumApproved">
      <div>
        <h3>You are approved for Platinum</h3>
      </div>
    </template>
    <template v-else-if="myUser && !myUser.pendingPlatinumApproval">
      <h3>Apply for Platinum</h3>
      <VForm class="mt-2">
        <!-- Why interested -->
        <span class="font-weight-bold text-sm">Why are you interested in Platinum?</span>
        <VTextarea
          v-model="platinumApprovalInfo.whyInterested"
          label=""
          rows="1"
          auto-grow
        />

        <!-- Friends or family members who are Platinum members -->
        <span class="font-weight-bold text-sm">Do you have any friends or team/family members that are Platinum members? If so, please share their names.</span>
        <VTextarea
          v-model="platinumApprovalInfo.friendsOrFamilyMembers"
          label=""
          rows="1"
          auto-grow
        />

        <!-- Type of membership interested in -->
        <span class="font-weight-bold text-sm">Are you interested in an individual Platinum membership and/or a group membership for your team/clients?</span>
        <VTextarea
          v-model="platinumApprovalInfo.membershipType"
          label=""
          rows="1"
          auto-grow
        />

        <!-- Other reservation services -->
        <span class="font-weight-bold text-sm">Do you currently have/use any other services for reservations? Credit cards, luxury concierges, etc. If so, please share.</span>
        <VTextarea
          v-model="platinumApprovalInfo.otherServices"
          label=""
          rows="1"
          auto-grow
        />

        <!-- Other reservation services -->
        <span class="font-weight-bold text-sm">Are you seeking a Verified profile? If so, please share affiliations/status for us to review.</span>
        <div class="text-center ma-0 pa-0">
          <span class=" text-sm">
            Verified profiles currently available for:<br>
            Public Figures: Leaders in Business, Entertainment, Sports<br>
            YPO & TIGER 21 members<br>
            HNW/UHNW clients of Private Wealth Management firms</span>
        </div>
        <VTextarea
          v-model="platinumApprovalInfo.seekingVerifiedProfile"
          label=""
          rows="1"
          auto-grow
        />

        <!-- Understanding of review process -->
        <span class="font-weight-bold text-sm">Please confirm that you understand that you can submit requests for Member Favorite restaurants (including your own) but review/acceptance is not guaranteed?</span>
        <div class="text-center">
          <VCheckbox
            v-model="platinumApprovalInfo.reviewUnderstanding"
            label="Yes, I understand"
          />
        </div>

        <div class="text-center">
          <!-- Submit button -->
          <p v-if="!platinumApprovalInfo.whyInterested || !platinumApprovalInfo.friendsOrFamilyMembers || !platinumApprovalInfo.membershipType || !platinumApprovalInfo.otherServices || !platinumApprovalInfo.seekingVerifiedProfile">
            Complete above fields to submit
          </p>
          <VBtn
            color="primary"
            :disabled="!platinumApprovalInfo.whyInterested || !platinumApprovalInfo.friendsOrFamilyMembers || !platinumApprovalInfo.membershipType || !platinumApprovalInfo.otherServices || !platinumApprovalInfo.seekingVerifiedProfile || !platinumApprovalInfo.reviewUnderstanding"
            @click="submitForm"
          >
            Submit
          </VBtn>
          <p class="text-caption">
            (approval in 24 hours or less)
          </p>
        </div>
      </VForm>
    </template>

    <template v-else-if="myUser && myUser.pendingPlatinumApproval">
      <div>
        <h3>Application Submitted!</h3>
        To expedite approval, please fully complete your profile.<br>
        <VBtn
          width="fit-content"
          class="profile-header-edit-button mt-4 pl-1 pr-1"
          variant="text"
          prepend-icon="mdi-edit"
          density="compact"
          :to="{path:'/membership'}"
          @click=" usersStore.editMyUser();"
        >
          Complete Profile
        </VBtn>
      </div>
    </template>
    <template v-else>
      <p>Please log in to apply for Platinum membership.</p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
ol{
  margin-left: 2rem;
}

ol li{
  list-style-type: decimal;
}

ul {
  margin-left: 2em;
}

ul li{
  list-style-type: circle;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: AclDemo
  allowLoggedInOnly: false
</route>
